import React from 'react';
import { Box, Flex } from '@chakra-ui/react';
import { CustomTimeSelectorTz } from '@/components/formBuilder/formFields/DateField/components/CustomTimeSelectorTz';
import { TimeZoneSelectorV1 } from '@/components/formBuilder/formFields/DateField/components/TimeZoneSelectorV1';
import { TimeSettingsProps } from '../types';

export const TimeSettings = ({
  selectedTime,
  setSelectedTime,
  timeFormat,
  selectedTimezone,
  setSelectedTimezone,
}: TimeSettingsProps) => {
  const handleTimeMenuOpen = () => {
    setTimeout(() => {
      const selectedTimeEl = document.querySelector(
        '.MyDropdown__option--is-selected'
      );
      if (selectedTimeEl) {
        selectedTimeEl.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'start',
        });
      }
    }, 50);
  };

  const handleTimeZoneMenuOpen = () => {
    setTimeout(() => {
      const selectedTimezoneEl = document.querySelector(
        '.MyDropdown__option--is-selected'
      );
      if (selectedTimezoneEl) {
        selectedTimezoneEl.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'start',
        });
      }
    }, 50);
  };

  return (
    <Flex gap="12px">
      <Box style={{ width: '50%' }}>
        <CustomTimeSelectorTz
          date={null}
          value={selectedTime}
          onChange={setSelectedTime}
          timeFormat={timeFormat}
          timeZone={selectedTimezone.key}
          metaData={{ intervalInMinutes: 15 }}
          inputProps={{
            menuPlacement: 'top',
            className: 'MyDropdown',
            classNamePrefix: 'MyDropdown',
            onMenuOpen: handleTimeMenuOpen,
            customStyles: {
              menuList: (base) => ({
                ...base,
                maxHeight: '200px',
                overflowY: 'auto',
              }),
            },
          }}
        />
      </Box>
      <Box style={{ width: '50%' }}>
        <TimeZoneSelectorV1
          value={selectedTimezone}
          onChange={(value) => {
            setSelectedTimezone(value);
          }}
          inputProps={{
            menuPlacement: 'top',
            className: 'MyDropdown',
            classNamePrefix: 'MyDropdown',
            onMenuOpen: handleTimeZoneMenuOpen,
            customStyles: {
              menuList: (base) => ({
                ...base,
                maxHeight: '200px',
                overflowY: 'auto',
              }),
            },
          }}
        />
      </Box>
    </Flex>
  );
};
